import { Component, OnInit } from '@angular/core';
import {ITableHeader} from "../../../../../interfaces/table-header";
import {TableHeaderService} from "../../../../../resources/services/table-header.service";

@Component({
  selector: 'ui-store-versions',
  templateUrl: './ui-store-versions.component.html'
})
export class UiStoreVersionsComponent implements OnInit {

  headers: ITableHeader[] = [
    this.tableHeaderService.version(),
    this.tableHeaderService.id(),
    this.tableHeaderService.createdAt({filter: false}),
    this.tableHeaderService.updatedAt({filter: false}),
  ];

  data: any = {
    version: 'Storename v.1.1.0',
    id: '0987654321',
    createdAt: new Date(),
    updatedAt: new Date(),
  };

  source: any[] = new Array(5).fill(this.data);

  constructor(private tableHeaderService: TableHeaderService) { }

  ngOnInit(): void {
  }

}
